module.exports = __webpack_public_path__ + "media/images/icons/twitter_white-bf444f010309ea85c1c147908a44aa7c.svg";